export const MLAppConfig = {
    RMDF_MDF_DETAILS: "ml/post-rmd-form",
    UPLOAD_FPF_EXCEL: "v1/ml/upload-fpf-excel",
    INVENTORY_UPDATE: "ml/post-inventory-updates"
}
